import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DemoService } from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';

// 
// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor, Query, ReturnOption, DataUtil } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import { IFilter } from '@syncfusion/ej2-angular-grids';
import {
  GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
  RowDataBoundEventArgs
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../app/services/global-functions.service';
import { Observable } from 'rxjs';

import * as _ from 'lodash';

@Component({
  selector: 'app-jobs-subjects-grid',
  templateUrl: './jobs-subjects-grid.component.html',
  styleUrls: ['./jobs-subjects-grid.component.css']
})
export class JobsSubjectsGridComponent implements OnChanges {

  @Input() job_id: number;
  @Input() brand_id?: number;
  @Input() job_status_code?: any;
  @Input() assigned_agent?: any; // single agent brand_id lookup

  // passed Values.
  // setup as observable?
  @Input() item_id?; // impliments on changes. // Base set to Job_ID
  @Input() item_data?; // if data.model is sent ;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id

  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?= null;
  @Input() item_brand_id?= null;
  @Input() item_subject_id?= null;
  @Input() item_subject_number?= '';

  @Input() show_buttons?= 'no'; // yes | no
  @Input() item_title?= '';
  @Input() widget_size?; // side | abstract | full | count


  @Input() file_number?: any; // subject file number
  @Input() subject_number?: any; // subject file number
  @Input() brand_type_id?: any; // subject file number
  @Input() reference_number?; any;


  @Output('addAutomationFromModal') addAutomationFromModal: EventEmitter<any> = new EventEmitter();
  @Output('addSubjectFromModal') addSubjectFromModal: EventEmitter<any> = new EventEmitter();
  
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 };
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  all_router_details: string;
  job_subjects_count: any;
  job_subjects_not_closed_count: any;
  job_subjects_grouped: any;
  subjects_only: any;


  constructor(private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe, public gfunc: GlobalFunctionsService) {

      // need to add this as routes does not work globally
    this.all_router_details = this.router.url;
     this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  }


  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
     this.job_id = changes.item_id.currentValue;
    
     // Load different quieries based on if agent associated -- Upgraded for muliple subjects picker to only get associated subjects who_service
     if (this.gfunc.current_base_route === '/agent/jobs/view-job' || this.widget_size == 'picker') {
      // only show the subjects if the agent is associated quiery.
      this.getAssignedAgentsJobsSubjectsGrid(this.job_id, this.brand_id, this.job_status_code, this.assigned_agent);
    } else {
      // Standard and works for all users except agents
      this.getJobsTableDataSubjects(this.job_id);
        this.getJobsTableDataSubjectsOnly(this.job_id);

    }


    if (changes.widget_size) {
    // widget size was not showing
    this.widget_size = changes.widget_size.currentValue;
    }

    // Grid Options
    // this.toolbarOptions = ['ExcelExport', 'Search'];
    this.toolbarOptions = []; // none
    this.initialPage = { pageSize: 5 };
    this.filterOptions = {
      type: 'Menu'
    };
    this.groupOptions = { columns: ['file_number'] }; // sets auto grouping for the grid
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' }] };

    this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
    // end date filter options
    // End Grid Options
    
    }

    }









  ngOnInit() {

   
  }



  // Setup the SyncFusion GRID


  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
    }
  }



  jobLink(job_id) {
    this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  }

  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  subjectEdit(subject_id) {
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  }


  refreshGrid() { // refresh the databutton
    // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);

    if (this.gfunc.current_base_route === '/agent/jobs/view-job'  || this.widget_size == 'picker') {
      // only show the subjects if the agent is associated quiery.
      this.getAssignedAgentsJobsSubjectsGrid(this.job_id, this.brand_id, this.job_status_code, this.assigned_agent);
    } else {
      // Standard and works for all users except agents
      this.getJobsTableDataSubjects(this.job_id);
    }

    this.grid.refresh();
  };


  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);

        this.job_subjects_count = this.subjects_urgent.length;
        this.job_subjects_not_closed_count = this.subjects_urgent.filter((item) => item.job_status !== 'CLOSED')
        .map((item) => +item.invoice_id).length;


        // using loadsash to group
   this.job_subjects_grouped = _.groupBy(
  this.subjects_urgent.filter(item => item.job_status !== 'CLOSED'),
  'file_number'
);

        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  getJobsTableDataSubjectsOnly(job_id) {
    this._demoService.getJobsTableDataSubjectsOnly(job_id).subscribe(
      data => {
        this.subjects_only = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        // this.subjects_only = DataUtil.parse.parseJson(data);

  

      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent) {
    this._demoService.getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);

        this.job_subjects_count = this.subjects_urgent.length;
        this.job_subjects_not_closed_count = this.subjects_urgent.filter((item) => item.job_status !== 'CLOSED')
        .map((item) => +item.invoice_id).length;


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

      //  this.grid.showSpinner();

      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
      //  console.log(args.data.items);



      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        // console.log(pdfdata.results);

        // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*   this.search_results = pdfdata;
          this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
          this.toastr.success( "Press Start To Process Que");  */
        // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
    }

    //  this.grid.hideSpinner();

  };


















  getBrandJobsTableData(brand_id) {
    this._demoService.getBrandJobsTableData(brand_id).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }

  getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
    this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent = data;
        this.open_jobs_count = this.subjects_urgent.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  // End Grid Items and Setup








}

